<ul
  role="tablist"
  data-cy="bis_tabs"
  class="nav nav-underline justify-content-center"
>
  @for (item of tabs(); track $index) {
    <li class="nav-item" data-cy="nav_bis_item">
      <h2
        role="tab"
        class="nav-link"
        [innerHTML]="item.label | safe"
        (keydown)="handleKeyPress($event)"
        (click)="changeTab(item.campaignType)"
        [class.active]="activeTab() === item.campaignType"
        [attr.aria-selected]="activeTab() === item.campaignType"
        [attr.tabindex]="activeTab() === item.campaignType ? '0' : '-1'"
        [style]="{
          fontFamily: item.fontFamily,
          color:
            activeTab() === item.campaignType ? item.selectedColor : item.color,
          borderBottom:
            activeTab() === item.campaignType ? item.selectedBorder : '',
        }"
      ></h2>
    </li>
  }
</ul>
